<div class="oab-sb-user" [class.oab-sb-user--open]="menuOpen">
  <button type="button" class="oab-sb-user__trigger"
    (click)="toggleMenu($event)" [attr.aria-expanded]="menuOpen" aria-haspopup="menu" [title]="name">
    <span class="oab-sb-user__avatar">
      @if (showImgAvatar) {
        <img [src]="srcImgAvatar" />
      }
      @if (!showImgAvatar) {
        <i class="icmn-user" aria-hidden="true"></i>
      }
    </span>
    <span class="oab-sb-user__info">
      <strong>{{ name }}</strong>
      @if (orgName() || sectorName) {
        <small>{{ orgName() || sectorName }}</small>
      }
    </span>
    <i class="fa fa-angle-up oab-sb-user__caret" aria-hidden="true"></i>
  </button>

  @if (menuOpen) {
    <ul class="oab-sb-user__menu" role="menu">
      <li class="oab-sb-user__menu-header">Conta</li>
      <li>
        <a href="javascript:void(0)" (click)="changeSetorModalVisible()">
          <i class="icmn-loop2"></i> Trocar organização/setor</a>
        </li>
        <li>
          <a href="javascript:void(0)" (click)="changePasswordModalVisible()">
            <i class="icmn-user"></i> Alterar senha</a>
          </li>
          <li class="oab-sb-user__menu-divider"></li>
          <li>
            <a href="javascript:void(0)" class="is-danger" (click)="logout()">
              <i class="icmn-exit"></i> Sair</a>
            </li>
          </ul>
        }
      </div>

      <oab-setores-modal-v2 [showModal]="isChangeSetorModalVisible" (handleModal)="hideSetorModal($event)"></oab-setores-modal-v2>
      <oab-alterar-senha-modal-v2 [showModal]="isChangePasswordModalVisible" (handleModal)="hidePasswordModal($event)"></oab-alterar-senha-modal-v2>